import axios from 'axios';
import { getApiUrl } from '../../../config';

export const requestGetBillingEmployees = () => axios.request({
    method: 'GET',
    url: `${getApiUrl()}/billing/employees`,
    withCredentials: true,
    crossorigin: true
});

export const requestUpdateEmployeeSalaryData = (employeeId, salaryData) => axios.request({
    method: 'PUT',
    url: `${getApiUrl()}/billing/employees/${employeeId}/salaryData`,
    data: salaryData,
    withCredentials: true,
    crossorigin: true
});

export const requestSetEmployeeTerminated = (employeeId, terminatedAt) => axios.request({
    method: 'PATCH',
    url: `${getApiUrl()}/billing/employees/${employeeId}/terminated`,
    data: { terminatedAt },
    withCredentials: true,
    crossorigin: true
});

export const requestGetEmployeePayments = (employeeId) => axios.request({
    method: 'GET',
    url: `${getApiUrl()}/billing/employees/${employeeId}/payments`,
    withCredentials: true,
    crossorigin: true
});

export const requestCreateEmployeePayment = (employeeId, payment) => axios.request({
    method: 'POST',
    url: `${getApiUrl()}/billing/employees/${employeeId}/payments`,
    data: payment,
    withCredentials: true,
    crossorigin: true
});

export const requestUpdateEmployeePayment = (employeeId, paymentId, payment) => axios.request({
    method: 'PUT',
    url: `${getApiUrl()}/billing/employees/${employeeId}/payments/${paymentId}`,
    data: payment,
    withCredentials: true,
    crossorigin: true
});

export const requestDeleteEmployeePayment = (employeeId, paymentId) => axios.request({
    method: 'DELETE',
    url: `${getApiUrl()}/billing/employees/${employeeId}/payments/${paymentId}`,
    withCredentials: true,
    crossorigin: true
});
